var map = {
	"./decidim/assemblies/decidim_assemblies.svg": "./vendor/bundle/ruby/3.2.0/gems/decidim-assemblies-0.29.5/app/packs/images/decidim/assemblies/decidim_assemblies.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./vendor/bundle/ruby/3.2.0/gems/decidim-assemblies-0.29.5/app/packs/images sync recursive ^\\.\\/.*$";